module.exports = __webpack_public_path__ + "static/10-aad04ffdac285d3a892b8556852a9c44.jpg";